const initial_state = {
    by_device_id: {},
};
const per_device_initial = {};
export const per_device_reducer = (state = per_device_initial, action) => {
    switch (action.type) {
        case 'SEND_Z3K_CUSTOM_COMMAND__REQUEST':
            return {
                ...state,
                [action.object_id]: {
                    state: action.state,
                    loading: true,
                    fail: false,
                    fail_message: '',
                    showDeviceIsOffline: false,
                },
            };
        case 'SEND_Z3K_CUSTOM_COMMAND__SUCCESS':
            return {
                ...state,
                [action.object_id]: {
                    state: 0,
                    loading: false,
                    fail: false,
                    fail_message: '',
                    showDeviceIsOffline: false,
                },
            };
        case 'SEND_Z3K_CUSTOM_COMMAND__FAIL':
            return {
                ...state,
                [action.object_id]: {
                    state: 0,
                    loading: false,
                    fail: true,
                    fail_message: action.error_message,
                    showDeviceIsOffline: false,
                },
            };
        case 'RESET_Z3K_CUSTOM_COMMAND__FAIL':
            return {
                ...state,
                [action.object_id]: {
                    state: 0,
                    loading: false,
                    fail: false,
                    fail_message: '',
                    showDeviceIsOffline: false,
                },
            };
        case 'SEND_Z3K_CUSTOM_COMMAND__SHOW_DEVICE_OFFLINE':
            return {
                ...state,
                [action.object_id]: {
                    state: 1,
                    loading: false,
                    fail: false,
                    fail_message: '',
                    showDeviceIsOffline: true,
                },
            };
        case 'SEND_Z3K_CUSTOM_COMMAND__CLOSE_DEVICE_OFFLINE':
            return {
                ...state,
                [action.object_id]: {
                    state: 1,
                    loading: false,
                    fail: false,
                    fail_message: '',
                    showDeviceIsOffline: false,
                },
            };
        default:
            return state;
    }
};
export const z3k_custom_command_reducer = (state = initial_state, action) => {
    switch (action.type) {
        case 'SEND_Z3K_CUSTOM_COMMAND__REQUEST':
        case 'SEND_Z3K_CUSTOM_COMMAND__SUCCESS':
        case 'SEND_Z3K_CUSTOM_COMMAND__FAIL':
        case 'RESET_Z3K_CUSTOM_COMMAND__FAIL':
        case 'SEND_Z3K_CUSTOM_COMMAND__SHOW_DEVICE_OFFLINE':
        case 'SEND_Z3K_CUSTOM_COMMAND__CLOSE_DEVICE_OFFLINE':
            return {
                ...state,
                by_device_id: {
                    ...state.by_device_id,
                    [action.device_id]: per_device_reducer(state.by_device_id[action.device_id], action),
                },
            };
        default:
            return state;
    }
};
